import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const dropoutComponent: ComponentDef = {
  id: 'dropout',
  name: 'Dropout',
  description: 'Randomly zero out a fraction of activations during training for regularization.',
  category: 'function',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    { name: 'rate', label: 'Dropout rate', type: 'number', default: 0.1, min: 0, max: 1, step: 0.05 },
    { name: 'variant', label: 'Variant', type: 'select', default: 'standard', options: [{ label: 'Standard', value: 'standard' }, { label: 'DropPath (Stochastic Depth)', value: 'droppath' }, { label: 'DropConnect', value: 'dropconnect' }] }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const seq_len = Number(params.seq_len);
    const rate = Number(params.rate);
    const variant = params.variant;

    const g = new GraphBuilder();
    g.input('x', [seq_len, d_model]);

    if (variant === 'droppath') {
      g.scale('branch', 'x', 'residual branch');
      g.dropout('drop', 'branch', rate);
      g.add('out', 'x', 'drop');
    } else if (variant === 'dropconnect') {
      g.input('weights', [d_model, d_model]);
      g.dropout('masked_weights', 'weights', rate);
      g.matmul('out', 'x', 'masked_weights', [seq_len, d_model]);
    } else {
      g.dropout('out', 'x', rate);
    }

    g.output('out', 'out');
    return g.build();
  }
};
